import React from 'react'
import { Input, FormField, Label } from 'pcln-design-system'
import { Search as SearchIcon, Warning as WarningIcon } from 'pcln-icons'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const TypeAheadLabel = styled(Label)`
  width: auto;
`

class TypeAheadInput extends React.Component {
  render() {
    const { autoHide, color, hasError, id, label, icon, passedThroughProps, hideIcon, ...props } = this.props
    return (
      <FormField {...passedThroughProps}>
        {label && <TypeAheadLabel autoHide={autoHide}>{label}</TypeAheadLabel>}
        {!hideIcon && (icon || <SearchIcon color='primary' size={24} />)}
        <Input
          id={id}
          autoComplete='off'
          color={color}
          ref={(elem) => {
            this.inputRef = elem
          }}
          {...props}
        />
        {Boolean(hasError) && <WarningIcon color='warning' size={24} />}
      </FormField>
    )
  }
}

TypeAheadInput.propTypes = {
  id: PropTypes.string,
  color: PropTypes.string,
  hasError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  icon: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  passedThroughProps: PropTypes.shape({
    style: PropTypes.object,
  }),
  hideIcon: PropTypes.bool,
  autoHide: PropTypes.bool,
}

TypeAheadInput.defaultProps = {
  passedThroughProps: null,
  hideIcon: false,
}

export default TypeAheadInput
